module.exports = __webpack_public_path__ + "img/icon-white-65.fb0f047c.svg";